import { ClassBookTemplate } from './class-book-template.model';
import { ClassBookTemplateInterface } from './class-book-template.interface';

export class ClassBookTemplateFactory {

    static empty(): ClassBookTemplate {
        return new ClassBookTemplate('', '', '', '', 'right', 0, {});
    }

    static fromObject(raw: ClassBookTemplateInterface | any): ClassBookTemplate {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new ClassBookTemplate(
            raw.id,
            raw.name,
            raw.iconLeft,
            raw.iconRight,
            raw.iconDefault,
            raw.order,
            raw.folder,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/class-book-templates/shared/class-book-template.factory.ts